import axios from "axios";
import { GET_ADMISSION_FORM_LOOKUPS, GET_DEGREE_REGISTRATION_DETAILS_BY_STUDENTID, GET_ENTRANCE_EXAMINATION_DETAILS_BY_STUDENTID, GET_EXPERIENCEDETAILS_BY_STUDENTID, GET_INTERNSHIPDETAILS_BY_STUDENTID, GET_NEET_DETAILS_BY_STUDENTID } from "./types";
const keys = require("../config/keys");

export const getExperienceDetailsByStudentId = (
  FormGroupID,
  StudentId
) => async dispatch => {
  await axios({
    method: "get",
    url:
      keys.ServicePath +
      "/api/AdmissionForm/GetExperienceDetailsByStudentId?FormGroupID=" +
      FormGroupID +
      "&StudentId=" +
      StudentId
  })
    .then(res => {
      if (res.data.success) {
        try {
          dispatch({
            type: GET_EXPERIENCEDETAILS_BY_STUDENTID,
            payload: res.data.data
          });
        } catch (exc) {
          console.log("exception", exc);
        }
      }
    })
    .catch(e => {
      console.log("catch error", JSON.stringify(e));
    });
};

export const getInternshipDetails = (
  FormGroupID,
  StudentId
) => async dispatch => {
  await axios({
    method: "get",
    url:
      keys.ServicePath +
      "/api/AdmissionForm/GetInternshipDetailsByStudentId?FormGroupID=" +
      FormGroupID +
      "&StudentId=" +
      StudentId
  })
    .then(res => {
      if (res.data.success) {
        try {
          dispatch({
            type: GET_INTERNSHIPDETAILS_BY_STUDENTID,
            payload: res.data.data
          });
        } catch (exc) {
          console.log("exception", exc);
        }
      }
    })
    .catch(e => {
      console.log("catch error", JSON.stringify(e));
    });
};

export const getEntranceExaminationDetails = (
  FormGroupID,
  StudentId
) => async dispatch => {
  await axios({
    method: "get",
    url:
      keys.ServicePath +
      "/api/AdmissionForm/getEntranceExaminationDetailsByStudentId?FormGroupID=" +
      FormGroupID +
      "&StudentId=" +
      StudentId
  })
    .then(res => {
      if (res.data.success) {
        try {
          dispatch({
            type: GET_ENTRANCE_EXAMINATION_DETAILS_BY_STUDENTID,
            payload: res.data.data
          });
        } catch (exc) {
          console.log("exception", exc);
        }
      }
    })
    .catch(e => {
      console.log("catch error", JSON.stringify(e));
    });
};

export const getDegreeRegistrationDetails = (
  FormGroupID,
  StudentId
) => async dispatch => {
  await axios({
    method: "get",
    url:
      keys.ServicePath +
      "/api/AdmissionForm/getDegreeRegistrationDetailsByStudentId?FormGroupID=" +
      FormGroupID +
      "&StudentId=" +
      StudentId
  })
    .then(res => {
      if (res.data.success) {
        try {
          dispatch({
            type: GET_DEGREE_REGISTRATION_DETAILS_BY_STUDENTID,
            payload: res.data.data
          });
        } catch (exc) {
          console.log("exception", exc);
        }
      }
    })
    .catch(e => {
      console.log("catch error", JSON.stringify(e));
    });
};

export const getNeetDetails = (
  FormGroupID,
  StudentId
) => async dispatch => {
  await axios({
    method: "get",
    url:
      keys.ServicePath +
      "/api/AdmissionForm/getNeetDetailsByStudentId?FormGroupID=" +
      FormGroupID +
      "&StudentId=" +
      StudentId
  })
    .then(res => {
      if (res.data.success) {
        try {
          dispatch({
            type: GET_NEET_DETAILS_BY_STUDENTID,
            payload: res.data.data || {}
          });
        } catch (exc) {
          console.log("exception", exc);
        }
      }
    })
    .catch(e => {
      console.log("catch error", JSON.stringify(e));
    });
};

export const getAdmissionFormLookups = (
  FormGroupID,
  StudentId
) => async dispatch => {
  await axios({
    method: "get",
    url:
      keys.ServicePath +
      "/api/AdmissionForm/getAdmissionFormLookups"
  })
    .then(res => {
      if (res.data.success) {
        try {
          dispatch({
            type: GET_ADMISSION_FORM_LOOKUPS,
            payload: res.data.data
          });
        } catch (exc) {
          console.log("exception", exc);
        }
      }
    })
    .catch(e => {
      console.log("catch error", JSON.stringify(e));
    });
};


// WEBPACK FOOTER //
// ./src/actions/getExperienceDetailsByStudentId.js